module.exports = "<div class=\"footerContainer\" id=\"footer\">\n  <div class=\"container\">\n    <h1 class=\"containerTitle\">FOOTER GOES HERE</h1>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main